<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <!-- <span id="log"></span> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      screenWidth: window.innerWidth,
      screenHeight: window.innerHeight,
      res: {},
    };
  },
  created() {
    // this.shareUrl = window.location.protocol+"//"+window.location.hostname +"/";
    console.log(this.shareUrl);
    let goUrl = this.isMobile();
    var code = this.getUrlKey("code");
    console.log(code);
    if (goUrl === 1) {
      //移动端地址

      var name = this.$route.name;
      if (name == "pchome" || name == "recharge") {
        this.$router.push({ name: "h5recharge", query: { code: code } });
      } else {
        this.$router.push({
          name: name ? name : "h5recharge",
          query: { code: code },
        });
      }
    } else {
      console.log(this.$route.name);
      var name = this.$route.name;
      if (name == "h5home" || name == "h5recharge") {
        this.$router.push({ name: "recharge", query: { code: code } });
      } else {
        this.$router.push({
          name: name ? name : "recharge",
          query: { code: code },
        });
      }
    }
  },

  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      localStorage.setItem("isiphone", flag);
      localStorage.setItem("ismobile", flag ? 1 : 0);
      let goUrl = flag ? 1 : 0;
      return goUrl;
    },
    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  },
};
</script>

<style  lang="less">
</style>



// WEBPACK FOOTER //
// src/App.vue